import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import Field from 'Component/Field';
import FIELD_TYPE from 'Component/Field/Field.config';
import Html from 'Component/Html';
import Loader from 'Component/Loader';
import { CustomerFormValuesType } from 'Type/Account.type';
import { MixType, RefType } from 'Type/Common.type';
import { GdprConsentType } from 'Type/Gdpr.type';

import './GdprConsent.style';

/** @namespace PeggysagePwa/Component/GdprConsent/Component */
export class GdprConsentComponent extends PureComponent {
    static propTypes = {
        location: PropTypes.string.isRequired,
        mix: MixType.isRequired,
        formId: PropTypes.string,
        isLoading: PropTypes.bool.isRequired,
        gdprConsents: PropTypes.arrayOf(GdprConsentType).isRequired,
        elemRef: RefType.isRequired,
        onChange: PropTypes.func.isRequired,
        defaultValues: CustomerFormValuesType.isRequired
    };

    static defaultProps = {
        formId: null
    };

    renderCheckbox(gdprConsent) {
        const {
            code, id, isRequired, text, ref
        } = gdprConsent;
        const {
            location, mix, formId, onChange, defaultValues
        } = this.props;

        return (
            <Field
              key={ id }
              type={ FIELD_TYPE.checkbox }
              // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
              label={ <span ref={ ref }><Html content={ text } /></span> }
              attr={ {
                  id: formId ? `${formId}_${location}_${code}` : `${location}_${code}`,
                  name: code,
                  defaultChecked: defaultValues[code] ?? false
              } }
              events={ {
                  onChange
              } }
              validateOn={ ['onChange'] }
              validationRule={ {
                  isRequired
              } }
              mix={ mix }
              addRequiredTag={ isRequired }
            />
        );
    }

    renderCheckboxes() {
        const { gdprConsents } = this.props;

        return gdprConsents.map(this.renderCheckbox.bind(this));
    }

    render() {
        const { isLoading, gdprConsents, elemRef } = this.props;

        if (!isLoading && (!gdprConsents || !gdprConsents.length)) {
            return null;
        }

        return (
            <div block="GdprConsent" ref={ elemRef }>
                <Loader isLoading={ isLoading } />
                { this.renderCheckboxes() }
            </div>
        );
    }
}

export default GdprConsentComponent;
